<template>
  <section>
    <v-toolbar color="#9190b5" dark prominent src="https://picsum.photos/1920/1080?random" height="176px">
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(145,144,181,.7), rgba(25,32,72,.7)"></v-img>
      </template>

      <v-toolbar-title class="ml-md-15">
        <v-list-item two-line v-if="authUser">
          <v-list-item-avatar size="120px" color="success">
            {{ authUser.first_name.slice(0,1) }}  {{ authUser.last_name ? authUser.last_name.slice(0,1) : null }}
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="headline">{{ authUser.full_name }}</v-list-item-title>
            <v-list-item-subtitle>{{ profile_type_label }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-toolbar-title>
      <v-spacer/>

      <template v-slot:extension>
        <v-tabs class="blur" right hide-slider>
          <v-tab>About</v-tab>
          <v-tab @click="password_dialog = !password_dialog">Change password</v-tab>
          <v-tab @click="delete_profile_dialog =! delete_profile_dialog">Delete profile</v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <v-container fluid v-if="user">
      <v-row>
        <v-col cols="12" md="5">
          <v-card>
            <v-toolbar dense flat>
              Basic information
              <v-spacer/>
              <v-btn small icon @click="base_info_dialog = !base_info_dialog">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider/>

            <v-list>
              <v-list-item>
                <v-list-item-icon><v-icon color="success">mdi-account</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>Nickname</v-list-item-subtitle>
                  <v-list-item-title>{{ user.nickname }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset/>

              <v-list-item>
                <v-list-item-icon><v-icon color="success">mdi-email</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>Sign-in email</v-list-item-subtitle>
                  <v-list-item-title>{{ user.email }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset/>

              <v-list-item>
                <v-list-item-icon><v-icon color="success">mdi-map-marker</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>Address</v-list-item-subtitle>
                  <v-list-item-title>{{ user.country }} {{ user.address }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset/>

              <v-list-item>
                <v-list-item-icon><v-icon color="success">mdi-video</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>Zoom Personal Meeting ID</v-list-item-subtitle>
                  <v-list-item-title>{{ user.zoom_id }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset/>

              <v-list-item>
                <v-list-item-icon><v-icon color="success">mdi-linkedin</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>LinkedIn</v-list-item-subtitle>
                  <v-list-item-title>{{ user.linked_in }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider inset/>

              <v-list-item>
                <v-list-item-icon><v-icon color="success">mdi-skype</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>Skype</v-list-item-subtitle>
                  <v-list-item-title>{{ user.skype }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>

        <v-col cols="12" md="7">
          <v-card class="mb-3">
            <v-toolbar dense flat>
              Other information
              <v-spacer/>
              <v-btn small icon @click="profile_dialog = !profile_dialog"><v-icon>mdi-pencil</v-icon></v-btn>
            </v-toolbar>
            <v-divider/>

            <template v-if="profile_type && profile_type === 'tutoringSolicitor'">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-action v-if="user.qualifications && user.qualifications.length === 0">
                    <v-icon color="warning">mdi-alert-circle</v-icon>
                  </v-list-item-action>
                  <v-list-item-action v-else/>
                  <v-list-item-content>
                    <v-list-item-subtitle>Qualification</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-content>
                    <v-list-item-title v-for="(item, idx) in user.qualifications" :key="idx" v-text="item"/>
                  </v-list-item-content>
                </v-list-item>

                <v-divider/>

                <v-list-item>
                  <v-list-item-action v-if="!user.individual_sra_id">
                    <v-icon color="warning">mdi-alert-circle</v-icon>
                  </v-list-item-action>
                  <v-list-item-action v-else/>
                  <v-list-item-content>
                    <v-list-item-subtitle>Individual SRA ID</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title v-text="user.individual_sra_id"/>
                  </v-list-item-content>
                </v-list-item>

                <v-divider/>

                <v-list-item>
                  <v-list-item-action></v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-subtitle>Chambers specification</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title v-text="user.chambers_specification"/>
                  </v-list-item-content>
                </v-list-item>
                <v-divider/>

                <v-list-item>
                  <v-list-item-action/>
                  <v-list-item-content>
                    <v-list-item-subtitle>Qualified in another jurisdiction</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title v-for="(item, idx) in user.jurisdiction" :key="idx" v-text="item.name"/>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </template>
            <template v-if="profile_type && profile_type === 'interviewer'">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-action></v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-subtitle>Interviewer type</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title v-for="(item, idx) in user.interviewer_type" :key="idx" v-text="item.text"/>
                  </v-list-item-content>
                </v-list-item>

                <v-divider/>

                <v-list-item>
                  <v-list-item-action></v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-subtitle>Interviewing experience</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title v-text="user.interviewer_experience"/>
                  </v-list-item-content>
                </v-list-item>

                <v-divider/>

                <v-list-item>
                  <v-list-item-action></v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-subtitle>Native speaker</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title v-if="!!user.native_speaker">YES</v-list-item-title>
                    <v-list-item-title v-else>NO</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider/>

                <v-list-item>
                  <v-list-item-action></v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-subtitle>British accent</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title v-if="!!user.british_accent">YES</v-list-item-title>
                    <v-list-item-title v-else>NO</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </template>
            <template v-if="profile_type && profile_type === 'aspiringSolicitor'">
              <v-list-item>
                <v-list-item-action></v-list-item-action>
                <v-list-item-content>
                  <v-list-item-subtitle>Education</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-content>
                  <v-list-item-title v-for="(item, idx) in user.educationLevels" :key="idx" v-text="item.name"/>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-card>

          <QWEForm :label="qwe_label"
                   v-model="user.experience"
                   :items="filtered_major_positions"
                   @change="loadUser"/>

          <v-card class="mt-5">
            <v-toolbar dense flat>
              Summary
              <v-spacer/>
              <v-btn small icon @click="summary_dialog = !summary_dialog"><v-icon>mdi-pencil</v-icon></v-btn>
            </v-toolbar>
            <v-divider/>

            <v-card-text class="ql-editor" v-html="user.summary"></v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-if="profile_type !== 'aspiringSolicitor'">
        <v-col cols="12" md="5">
          <v-card class="mb-3">
            <v-toolbar dense>Practice areas</v-toolbar>
            <v-card-text>
              <v-select label="Practice areas" v-model="user.practice_areas"
                        :items="practice_areas"
                        item-text="name"
                        item-value="id"
                        multiple
                        chips
                        deletable-chips
                        outlined
                        @change="updateUserPracticeAreas"
              ></v-select>
            </v-card-text>
          </v-card>
          <v-card class="mb-3">
            <v-toolbar dense>Session types</v-toolbar>
            <v-card-text>
              <v-select label="Session types" v-model="user.session_types"
                        :items="session_types"
                        item-text="name"
                        item-value="id"
                        multiple
                        chips
                        deletable-chips
                        outlined
                        @change="updateUserSessionTypes"
              ></v-select>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="7">
          <v-card>
            <v-toolbar dense>Session type limits</v-toolbar>
            <v-data-iterator :items="limits"
                             hide-default-footer
                             disable-pagination
            >
              <template v-slot:default="props">
                <template v-for="(item, idx) in props.items">
                  <v-card tile v-bind:key="idx">
                    <v-list-item>
                      <v-list-item-content>{{ item.name }}</v-list-item-content>
                      <v-list-item-content>
                        <v-slider v-model="item.count" color="primary" track-color="success" class="mt-7"
                                  thumb-label="always"
                                  ticks
                                  hide-details
                                  min="0" max="30">
                          <template v-slot:prepend>
                            <v-icon color="primary" @click="item.count--">mdi-minus</v-icon>
                          </template>

                          <template v-slot:append>
                            <v-icon color="primary" @click="item.count++">mdi-plus</v-icon>
                          </template>
                        </v-slider>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </template>
              </template>
            </v-data-iterator>
            <v-card-actions class="justify-center">
              <v-btn class="box-shadow" color="primary" @click="loadLimits">Discard</v-btn>
              <v-btn class="box-shadow" color="success" @click="updateLimits">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-if="authUserCourseLeader">
        <v-col>
          <v-card>
            <v-list-item>
              <v-list-item-icon><v-icon>mdi-google</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Google client</v-list-item-title>
                <v-list-item-subtitle>GoogleCalendar, GoogleDrive, GoogleDocs</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn color="primary" class="box-shadow" @click="getGoogleAuthUri">connect</v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="base_info_dialog" @click:outside="base_info_dialog = false, discardChanges()" max-width="600px">
      <v-form @submit="updateUser">
        <v-card>
          <v-toolbar dark color="success">
            <v-btn icon dark @click="base_info_dialog = false, discardChanges()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Edit base info</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text type="submit">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text v-if="user">
            <v-text-field label="First name"
                          v-model="user.first_name"
                          color="secondary"
                          validate-on-blur
                          disabled
                          :error-messages="api_errors['first_name']"
            />

            <v-text-field label="Last name"
                          v-model="user.last_name"
                          color="secondary"
                          validate-on-blur
                          disabled
                          :error-messages="api_errors['last_name']"
            />

            <template v-if="profile_type && profile_type === 'aspiringSolicitor'">
              <v-text-field label="Current employer, if any"
                            v-model="user.current_employer"
                            color="secondary"
                            validate-on-blur
                            :error-messages="api_errors['current_employer']"
              />
            </template>

            <v-text-field label="Nickname"
                          v-model="user.nickname"
                          color="secondary"
                          validate-on-blur
                          :error-messages="api_errors['nickname']"
            />

            <v-select label="Country"
                      v-model="user.country"
                      :items="countries"
                      item-text="name"
                      item-value="name"
                      :error-messages="api_errors['country']"
            />

            <v-text-field label="Address"
                          v-model="user.address"
                          color="secondary"
                          validate-on-blur
                          :error-messages="api_errors['address']"
            />

            <v-text-field label="Zoom Personal Meeting ID"
                          v-model="user.zoom_id"
                          color="secondary"
                          placeholder="https://us04web.zoom.us/j/XXXXXXXXX"
                          validate-on-blur
                          :error-messages="api_errors['zoom_id']"
            />

            <v-text-field label="LinkedIn"
                          v-model="user.linked_in"
                          color="secondary"
                          placeholder="https://www.linkedin.com/in/your-address/"
                          validate-on-blur
                          :error-messages="api_errors['linked_in']"
            />

            <v-text-field label="Skype"
                          v-model="user.skype"
                          color="secondary"
                          validate-on-blur
                          :error-messages="api_errors['skype']"
            />
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="profile_dialog" @click:outside="profile_dialog = false, discardChanges()" max-width="600px">
      <v-form @submit="updateProfile">
        <v-card>
          <v-toolbar dark color="success">
            <v-btn icon dark @click="profile_dialog = !profile_dialog, discardChanges()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Experience</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text type="submit">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <template v-if="user && profile_type && profile_type === 'tutoringSolicitor'">
            <v-card-text>
              <v-combobox label="Qualification"
                          v-model="user.qualifications"
                          :items="qualifications"
                          color="secondary"
                          item-text="name"
                          item-value="name"
                          multiple
                          :error-messages="api_errors['qualifications']"
              />
              <v-text-field label="Individual SRA ID"
                            v-model="user.individual_sra_id"
                            color="secondary"
                            :error-messages="api_errors['individual_sra_id']"
              />
              <v-text-field label="Chambers specification"
                            v-model="user.chambers_specification"
                            color="secondary"
                            item-text="name"
                            item-value="id"
                            :error-messages="api_errors['chambers_specification']"
              />
              <v-combobox label="Jurisdiction"
                          v-model="user.jurisdiction"
                          :items="countries"
                          color="secondary"
                          item-text="name"
                          item-value="id"
                          multiple
                          :error-messages="api_errors['jurisdiction']"
              />
            </v-card-text>
          </template>
          <template v-if="user && profile_type && profile_type === 'interviewer'">
            <v-card-text class="pb-0">
              <v-combobox label="Background"
                          v-model="user.interviewer_type"
                          :items="interviewer_type_options"
                          color="secondary"
                          multiple
                          :error-messages="api_errors['interviewer_type']"
              />

              <v-select label="Interviewing experience"
                        v-model="user.interviewer_experience"
                        :items="int_experience_options"
                        color="secondary"
                        :error-messages="api_errors['interviewer_experience']"
              />
            </v-card-text>

            <v-list-item>
              <v-list-item-content>Native speaker</v-list-item-content>
              <v-list-item-action>
                <v-switch v-model="user.native_speaker" color="secondary"
                          :error-messages="api_errors['native_speaker']"
                />
              </v-list-item-action>
            </v-list-item>
            <v-divider/>

            <v-list-item>
              <v-list-item-content>British accent</v-list-item-content>
              <v-list-item-action>
                <v-switch v-model="user.british_accent" color="secondary"
                          :error-messages="api_errors['british_accent']"
                />
              </v-list-item-action>
            </v-list-item>
            <v-divider/>
          </template>
          <template v-if="user && profile_type && profile_type === 'aspiringSolicitor'">
            <v-card-text>
              <v-combobox
                  v-model="user.educationLevels"
                  :items="educationLevels"
                  item-text="name"
                  item-value="slug"
                  color="secondary"
                  label="Education levels"
                  multiple
                  :error-messages="api_errors['educationLevels']"
              />
            </v-card-text>
          </template>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="summary_dialog" @click:outside="summary_dialog = false, discardChanges()">
      <v-form @submit="updateSummary">
        <v-card>
          <v-toolbar dark color="success">
            <v-btn icon dark @click="summary_dialog = !summary_dialog, discardChanges()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Summary</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text type="submit">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <vue-editor v-if="user" id="course-description-edit" v-model="user.summary" :editor-toolbar="toolbar"/>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="password_dialog" @click:outside="password_dialog = false, discardChanges()" max-width="600px">
      <v-form @submit="updatePassword">
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="password_dialog = false,discardChanges()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Change password</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text class="box-shadow" type="submit">Apply</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            <v-text-field label="New password"
                          v-model="password"
                          color="primary"
                          outlined
                          :error-messages="api_errors['password']"
            />

            <v-text-field label="Confirm the new password"
                          v-model="password_confirmation"
                          color="primary"
                          outlined
                          :error-messages="api_errors['password']"
            />
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog v-model="delete_profile_dialog" max-width="500px">
      <v-alert prominent type="error" class="mb-0">
        <v-card flat color="transparent">
          <v-card-text>
            Attention! In order to avoid accidental deletions, the administrators are processing your deletion requests.
            Want to send a request to delete your profile?
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn @click="delete_profile_dialog =! delete_profile_dialog">No</v-btn>
            <v-btn @click="sendDeleteRequest">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-alert>
    </v-dialog>
  </section>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapGetters, mapActions } from 'vuex'
import QWEForm from "@/views/profile/QWEForm";

export default {
  components: {
    QWEForm
  },
  data: () => ({
    user: null,
    profile_type_options: [
      {value: 'tutoringSolicitor', text: 'Tutoring Solicitor'},
      {value: 'interviewer', text: 'Interviewer'},
      {value: 'aspiringSolicitor', text: 'Aspiring Solicitor'},
    ],
    session_limits_headers: [
      { text: 'Session type', value: 'name' },
      // { text: 'Type', value: 'status' },
      { text: 'Count', value: 'count' },

    ],
    base_info_dialog: false,
    profile_info_dialog: false,
    password_dialog: false,
    delete_profile_dialog: false,

    profile_dialog: false,

    summary_dialog: false,
    toolbar: [
      [
        { header: [false, 1, 2, 3, 4, 5, 6] },
        "bold", "italic", "underline"
      ],
      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" }
      ],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: []}],
      ["link", "formula"],
    ],

    business_dialog: false,
    interviewer_experience_dialog: false,

    interviewer_type_options: [
      { text: 'Academic', value: 'academic' },
      { text: 'Acting', value: 'acting' },
    ],
    int_experience_options: [
      { text: '0-1 year', value: '0-1' },
      { text: '2-3 years', value: '2-3' },
      { text: '5+', value: '5+' },
    ],
    education_levels_dialog: false,
    qualification_dialog: false,
    jurisdiction_dialog: false,

    limits: [],

    password: '',
    password_confirmation: '',
    api_errors: [],
  }),
  computed: {
    ...mapGetters({
      authUser: 'getAuthUser',
      profile_type: 'getAuthUserProfileType',
      profile_type_label: 'getAuthUserProfileTypeLabel',
      authUserSessionLimits: 'getAuthUserSessionLimits',
      countries: 'getCountries',
      educationLevels: 'getEducationLevels',
      businessTypes: 'getBusinessTypes',
      majorPositions: 'getMajorPositions',
      qualifications: 'getQualifications',

      session_types: 'getSessionTypes',
      practice_areas: 'getPracticeAreas',
    }),
    qwe_label: function() {
      if(this.profile_type && this.profile_type === 'tutoringSolicitor') {return 'Previous post-qualified experience';}
      if(this.profile_type && this.profile_type === 'interviewer') {return 'Previous work experience';}
      return 'Qualifying work experience (QWE)'
    },
    filtered_major_positions: function () {
      return this.majorPositions.filter(item => this.profile_type === item.profile_type)
    }
  },
  watch: {
    'authUser': function (val) {
      this.user = Object.assign({}, val)
    }
  },
  mounted() {
    this.user = Object.assign({}, this.authUser)
    this.handleGoogleAuthCallback()
    this.loadLimits()

    //load only on profile page
    this.loadCountries()
    this.loadBusinessTypes()
    this.loadMajorPositions()
    this.loadEducationLevels()
    this.loadQualifications()
  },
  methods: {
    ...mapActions({
      loadUser: 'loadUser',
      loadAuthUserSessionLimits: 'loadAuthUserSessionLimits',

      loadCountries: 'loadCountries',
      loadBusinessTypes: 'loadBusinessTypes',
      loadMajorPositions: 'loadMajorPositions',
      loadEducationLevels: 'loadEducationLevels',
      loadQualifications: 'loadQualifications',
    }),
    discardChanges() {
      this.user = Object.assign({}, this.authUser)
    },
    updateUser(e) {
      e.preventDefault()
      this.api_errors = []
      this.axios.post('api/user/update', this.user)
          .then(() => {
            this.loadUser()
            this.base_info_dialog = false
            this.$notify('Success!', 'success')
          })
          .catch(errors => {this.api_errors = errors.response.data.errors})
    },
    updateSummary(e) {
      e.preventDefault()
      this.api_errors = []
      this.axios.post('api/user/update-summary', {summary: this.user.summary})
          .then(() => {
            this.loadUser()
            this.summary_dialog = false
            this.$notify('Success!', 'success')
          })
          .catch(errors => {this.api_errors = errors.response.data.errors})
    },
    updateProfile(e) {
      e.preventDefault()
      this.api_errors = []
      this.axios.post('api/user/update-profile', {
        // ...this.user,
        //ts
        business_type_id: this.user.business_type_id,
        individual: this.user.individual,
        firm_name: this.user.firm_name,
        firm_registration_number: this.user.firm_registration_number,
        firm_sra_id: this.user.firm_sra_id,
        individual_sra_id: this.user.individual_sra_id,
        chambers_specification: this.user.chambers_specification,
        //int
        interviewer_type: this.user.interviewer_type,
        interviewer_experience: this.user.interviewer_experience,
        native_speaker: this.user.native_speaker,
        british_accent: this.user.british_accent,
        // other
        education_levels: this.user.educationLevels.map(item => item.id),
        qualifications: this.user.qualifications.map(item => item.name || item),
        jurisdiction: this.user.jurisdiction.map(item => item.id),
        summary: this.user.summary,
      })
          .then(() => {
            this.profile_dialog = false
            this.$notify('Success!', 'success')
            this.loadUser()
          })
          .catch(errors => {this.api_errors = errors.response.data.errors})
    },
    updatePassword(e) {
      e.preventDefault()
      this.api_errors = []
      this.axios.post('api/user/update-password', {
        password: this.password,
        password_confirmation: this.password_confirmation,
      })
          .then(() => {
            this.$notify('Success!', 'success')
          })
          .catch(errors => {this.api_errors = errors.response.data.errors})
    },

    getGoogleAuthUri() {
      this.axios.get('api/google-accounts/login')
          .then(response => { window.location.replace(response.data.data) })
    },
    handleGoogleAuthCallback() {
      if(this.$route.query.code) {
        this.axios.post('api/google-accounts/callback', { ...this.$route.query })
            .then(() => { this.$notify('Success!', 'success') })
            .catch(errors => {
              console.log(errors.response.data)
            })
            .then(() => {window.location.replace(window.location.origin + '/profile')})
      }
    },
    sendDeleteRequest() {
      this.app_loading = true
      this.axios.post('api/user/delete')
          .then(() => {})
          .catch(() => {})
          .then(() => {
            this.app_loading = false
            this.delete_profile_dialog = false
            this.$router.push({name: 'Login'})
          })
    },
    updateUserPracticeAreas(changes) {
      this.axios.put('api/user/practice-areas', {practice_areas: changes})
    },
    updateUserSessionTypes(changes) {
      this.axios.put('api/user/session-types', {session_types: changes})
    },

    loadLimits() {
      this.axios.get(`api/user/session-limits`)
          .then(({data}) => {
            let local = this.session_types.map(item => item)
            this.limits = local.map(item => {
              let exists = data.data.find(limit => limit.id === item.id)
              if(exists) return ({...item, count: exists.count})
              return ({...item, count: 0})
            })
          })
    },
    updateLimits() {
      this.app_loading = true
      this.axios.put(`api/user/session-limits`, {limits: this.limits})
          .then(({data}) => { this.limits = data.data})
          .catch(errors => {this.api_errors = errors.response.data.errors})
          .then(() => {
            this.app_loading = false
          })
    }
  }

}
</script>